<!--
    Name:			Reciept.vue
    Description:	Show the reciept as a reciept
-->
<template>

    <div class="reciept" :class="accentClass">

        <div :class="['m-2', getBonChefSelectionState(Order)]" v-on:click="scrollto">
          
            <div v-if="Order.showTimestamp" class="interval-time-marker">
                {{Order.intervalTimeStamp | formatTime}}
                <div class="time-marker-line"></div>
            </div>

            <div class="orderinfo p-2 accent-background " v-on:click.stop="showOrderInAlert('')">

                <div class="ordernr">{{Order.orderNr}}&nbsp;<span style="float:right">{{Order.name}}</span></div>
                <div class="order-prop"><span class="label"><translate item="OrderDetail.OrderStatus.Created" /></span>: {{Order.createDate | formatDayTime}}</div>
                <div class="order-prop"><span class="label"><translate item="OrderDetail.OrderStatus.Preparation" /></span>: {{Order.startDate | formatDayTime}} - {{Order.calculatedReadyDate | formatTime}}</div>
                <div class="order-prop" v-if="Order.calculatedShippedDate != null">
                    <span class="label">Bezorging</span>:
                    <span>{{Order.calculatedShippedDate | formatTime}}</span>
                </div>
                <div class="order-prop">
                    <span class="label"><translate item="OrderDetail.OrderStatus.RequestedReadyTime" /></span>:
                    <span v-if="Order.desiredReadyDate != null">{{Order.desiredReadyDate | formatDayTime}}</span><span v-else><translate item="OrderDetail.OrderStatus.RequestedReadyTime.ASAP" /></span>
                </div>

                <div class="order-prop order-delivery">
                    <span v-if="Order.deliveryMethod == 0"><translate item="OrderDetail.OrderStatus.DeliveryMethod.EatHere" /> </span>
                    <span v-if="Order.deliveryMethod == 1"><translate item="OrderDetail.OrderStatus.DeliveryMethod.PickUp" /> </span>
                    <span v-if="Order.deliveryMethod == 2"><translate item="OrderDetail.OrderStatus.DeliveryMethod.Deliver" /> </span>
                </div>
            </div>

            <div class="products p-2">
                <template class="menu-holder" v-for="product in dishGroupHolderProducts">
                    <div :class="['product-name mnu', getProductClass(product, false)]">{{product.quantity}} {{product.name}}	</div>
                    <div :class="['mnu-child', getProductClass(child, false)]" :key="child.id" v-for="child in product.children">
                        {{child.quantity}} {{child.name}} <span :class="getProductClass(prep, true)" :key="prep.id" v-for="prep in child.children"> + {{prep.quantity > 1 ? prep.quantity + ' ' : ''}}{{prep.name}}</span>
                        <i :class="getBonChefClass(child)"></i>
                    </div>
                </template>

                <div :key="product.id" v-for="product in normalProducts">
                    <div :class="getProductClass(product)">
                        {{product.quantity}} {{product.name}} <span :class="getProductClass(prep, true)" :key="prep.id" v-for="prep in product.children"> + {{prep.quantity > 1 ? prep.quantity + ' ' : ''}}{{prep.name}}</span>
                        <i :class="getBonChefClass(product)"></i>
                    </div>
                </div>
            </div>

            <div :class="['status-bar', {'fromHistory':Order.fromHistorySearch}]">
                <div :key="status" v-if="!Order.fromHistorySearch" v-for="status in StatusIds" :class="getAccentClass(status)" v-on:click.stop="setStatus(status)">
                    <div class='btn btn-accent'>
                        <span>
                            <i v-if="status == Order.status" class="icon icon-checkmark-small"></i>
                            <i v-if="status != Order.status" class="icon-number">{{status + 1}}</i>
                        </span>
                    </div>
                </div>
            </div>
            
            <div class="order-remark" :class="{ 'order-remark-empty': remarks.length === 0, 'with-tablenumber' : Order.tableNumber.length }">
                <div class="order-course-name" v-if="Order.courseName">
                    <div class="order-course-name-in"> {{Order.courseName}}</div>
                </div>
                <div class="order-remark-content">
                    <div class="order-remark-wrp" v-for="remark in remarks">
                        {{remark.remark}}
                    </div>

                </div>
                
                <div class="order-table-number" v-if="Order.tableNumber.length ">
                    {{Order.tableNumber}}
                </div>
            </div>

        </div>
    </div>
</template>

<script>

    // Import the EventBus
    import { EventBus } from '../repositories/Eventbus';   
    import timeStore from '../repositories/TimeManager';
    import orderDetail from '../components/OrderDetail';
    import Vue from 'vue';
    import { ShowOn, OrderStatus, BatchStatus } from '../repositories/Constants';
    import logRepostory from '../repositories/LogRepository';
    import configRepository from '../repositories/ConfigRepository';
    import bonchefRepository from '../repositories/BonchefRepository';
    import translate from '../components/translate'

    const Reciept = {

        components: { translate },

        props: {
            Order: { type: Object },
            Units: { type: Array },
            AccentColor: { type: Number },
            styleProp: { type: Object }
        },

        data: function () {
            return {
                //createX: 0,
                startX: 0,
                endX: 0,
                StatusIds: configRepository.statusIds,
                showBonChef: this.$signalR.showBonChef
            };
        },


        methods: {

            showOrderInAlert: function (message) {

                // create orderDetail vue compnent
                // https://css-tricks.com/creating-vue-js-component-instances-programmatically/
                var ComponentClass = Vue.extend(orderDetail)
                // set properties
                var _orderDetail = new ComponentClass({
                    propsData: { Order: this.Order, Message: message, Units : this.Units }
                });
                _orderDetail.$mount();

                // https://sweetalert2.github.io/#configuration
                this.$fire({
                    //title: "Bestelling #" + this.Order.orderNr,
                    html: '', // _orderDetail.$el.outerHTML,
                    width: '50rem',
                    padding: '0px',
                    showConfirmButton: false,
                    customClass: {
                        container: 'order-detail'
                    },
                    onOpen: function (ell) {
                        ell.children[1].appendChild(_orderDetail.$el);
                    }
                }).then(() => {
                    _orderDetail.$destroy();
                });

            },

            /**
             * Gets the width of the product in percentages of the whole order
             * @param product
             */
            getProductWith: function (product) {

                // is the product devided into multiple batches?
                if (product.batches && product.batches.length > 1) {
                    var starttime = new Date(product.batches.reduce(function (batchA, batchB) {
                        // problem: the batch start/endtime does not always match the product start/endtime. the product does not contain a starttime.
                        // becouse the products are always alligned to the right, we can calculate the starttime of the product.
                        return batchA.endTime < batchB.endTime ? batchA : batchB;
                    }).endTime - (product.cookingTime * 1000));

                    var endtime = product.batches.reduce(function (a, b) { return a.endTime > b.endTime ? a : b; }).endTime;
                    var span = endtime - starttime;
                    return ((span / 10) / this.Order.totalTime).toFixed(4)
                }

                return ((product.cookingTime / this.Order.totalTime) * 100).toFixed(4);
            },

            getProductRight: function (product) {
                // the order can be devided over multiple batches, this product may be the first.
                if (product.batches && product.batches.length && this.Order.batches && this.Order.batches.length > 1) {
                    var endtime = product.batches.reduce(function (a, b) { return a.endTime > b.endTime ? a : b; }).endTime;
                    var span = this.Order.calculatedReadyDate - endtime;
                    return ((span / 10) / this.Order.totalTime).toFixed(4)
                }

                return 0;
            },

            /**
            * Method scrolls the timline to the position of this order.
            * */
            scrollto: function () {
                EventBus.$emit('scroll-x-to', this.Order);
            },

            getProductClass: function (product, isPrepMethod) {
               
                var className = {};

                //// shortcut.
                if (isPrepMethod && product.prepMethodPlanAction == 0) {
                    return className;
                }

                className['product-name'] = 1;
                if (this.Units == null) {
                    // pick screen
                    className['unit-active'] = 1;
                } else if (typeof this.Units == undefined) {
                    //  console.log('units undefined');
                    className['unit-active'] = 1;
                }
                else {
                    try {
                        if (product.isDishGroupholder) {
                            if (product.children && this.Units.some(a => product.children.some(c => c.batches && c.batches.some(b => b.unitGroupId == a.id)))) {
                                className['unit-active'] = 1;
                            }
                        }
                        else {
                            if (product.batches && this.Units.some(a => product.batches.some(b => b.unitGroupId == a.id))) {
                                className['unit-active'] = 1;
                            }
                        }
                    } catch (e) {
                        className['unit-error'] = 1;
                        if (!window.localStorage.getItem('reload_productId' + product.id)) {
                            window.localStorage.setItem('reload_productId' + product.id, '1');
                            logRepostory.addLog('Reload browser, batch not found for order' + this.Order.orderNr);
                            window.location.reload(true);
                        }
                    }

                }
                return className;
            },

            getBonChefClass: function (product) {

                var className = "bonchef-status icon icon-checkmark-round ";


                var batches = product.batches; 

                if (batches) {

                    var length = batches.filter(a => a.bonchef).length;

                    if (batches.length === 0 || length === 0) {
                        className += "bonchef-pending";
                    } else {
                        className += (batches.length === length) ? "bonchef-complete" : "bonchef-partial";
                    }
                }                

                return className;
            },

            getBonChefSelectionState: function (order) {

                // check if order has open bonchef
                if (bonchefRepository.bonchefInstructionsWaiting > 0) {
                    const firstBonchef = bonchefRepository.openBonchefInstructions[0];
                    if (firstBonchef.batches.some(b => b.orderIds.includes(order.id))) {
                        return 'currentBonchef';
                    }
                }

                // check if order is part of priorBonchef manual selected
                const bonchef = bonchefRepository.que.find(q => q.showPriorBonchef);
                if (bonchef) {
                    // Loop through each batch in the order
                    for (const batch of order.batches) {
                        // Check if the batch is in the que based on its ID
                        if (bonchef.batches.some(b => b.id === batch.id)) {
                            return 'manualSelected';
                        }
                    }
                }

            },

            getAccentClass: function (statusId) {
                var className = {};
                className['accent' + statusId] = 1;

                var index = this.StatusIds.indexOf(statusId);
                var currentIndex = this.StatusIds.indexOf(this.Order.status);

                if (this.Order.status > BatchStatus.Prepared) {
                    if (statusId < BatchStatus.Prepared) {
                        className['disabled'] = true;
                    }
                } else if ( index < currentIndex) {
                    className['disabled'] = true;
                }
                                
                return className;
            },

            getStatusIconClass: function (statusId) {
                var className = {};
                className['icon'] = 1;
                className[OrderStatus[statusId]] = 1;
                return className;
            },

            setStatus: function (statusId) {
                var index = this.StatusIds.indexOf(statusId);
                var currentIndex = this.StatusIds.indexOf(this.Order.status);

                if (this.Order.status > BatchStatus.Prepared) {
                    if (statusId < BatchStatus.Prepared) {
                        return;
                    }
                } else if (index < currentIndex) {
                    return;
                }
                                
                this.$signalR.setOrderStatus(this.Order, statusId);
            }
        },

        computed: {

            /**
            * Returns the remarks filterd by there showon property 
            **/
            remarks: function () {
                return this.Order.remarks.filter(a => a.showOn == ShowOn.Both || a.showOn == ShowOn.KitchenPlanning);
            },

            /** Returns the accent class according to the status */
            accentClass: function () {
                var className = {};
                className['accent' + this.Order.status] = 1;
                className['futurePending'] = this.Order.futurePending;
                className['deliverymethod' + this.Order.deliveryMethod] = 1;

                // class name for the configurable timespan
                className['interval-odd'] = (this.Order.isIntervalEven == 1);
                className['interval-even'] = (this.Order.isIntervalEven == 2);
                                

                return className;
            },

            /** Returns the order width */
            orderWidth: function () {
                return timeStore.calculateWidth(this.Order.totalTime);
            }
            ,

            /** Returns the starttime of the timestore, used to calculate the starting position of the order */
            timstoreStartTime: function () {
                return timeStore.state.startTime;
            },

            /**
             * Returns the products which are dishgroupholders
             **/
            dishGroupHolderProducts: function () {
                return this.Order.products.filter(product => product.isDishGroupholder);
            },

            /**
             * Returns the normal products
             **/
            normalProducts: function () {
                return this.Order.products.filter(product => !product.isDishGroupholder);
            }

        },

        watch: {

            "Order.calculatedReadyDate": function () { //newValue, oldValue
                var _this = this;

                if (_this.Order.calculatedReadyDate) {
                    _this.startX = timeStore.calculateXPosition(_this.Order.startDate);
                } else {
                    this.startX = 0;
                }

            },

            "Order.startDate": function () {
                var _this = this;

                if (_this.Order.startDate) {
                    _this.endX = timeStore.calculateXPosition(_this.Order.calculatedReadyDate);
                } else {
                    this.endX = 0;
                }
            },

            "timstoreStartTime": function () {
                var _this = this;

                if (_this.Order.calculatedReadyDate) {
                    _this.startX = timeStore.calculateXPosition(_this.Order.startDate);
                } else {
                    this.startX = 0;
                }

            },
        },

        mounted: function () {

            // todo : combine this logic with drag-drop in timeline.vue
            // this.createX = timeStore.calculateXPosition(_this.Order.createDate);

            if (this.Order.calculatedReadyDate)
                this.startX = timeStore.calculateXPosition(this.Order.startDate);

            if (this.Order.startDate)
                this.endX = timeStore.calculateXPosition(this.Order.calculatedReadyDate);
          
        }


    };

    export { Reciept as default };

</script>

<style>
</style>